import { apiBasePath } from '../baseUrl';
import { apiUrl } from '../../utils/api';

export const missingDataFeedSourcesApi = apiBasePath.injectEndpoints({
  endpoints: (build) => ({
    getMissingDataFeedSources: build.query({
      query: () => apiUrl.missingDataFeedSources,
      transformResponse: (responseData) => ({
        data: responseData.data,
      }),
      providesTags: ['MissingDataFeedSources'],
    }),
    getMissingDataFeedJobTypes: build.query({
      query: () => apiUrl.missingDataFeedJobTypes,
      transformResponse: (responseData) => ({
        data: responseData.data,
      }),
      providesTags: ['MissingDataFeedJobTypes'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetMissingDataFeedSourcesQuery,
  useLazyGetMissingDataFeedSourcesQuery,
  useGetMissingDataFeedJobTypesQuery,
  useLazyGetMissingDataFeedJobTypesQuery,
} = missingDataFeedSourcesApi;
